import React from 'react';
import PropTypes from 'prop-types';
import { BlobProvider } from '@react-pdf/renderer';
import RelatorioPDF from './RelatorioPDF'; // Importe seu componente de PDF
import Button from '../common/Button'; // Importando o botão genérico

function DownloadPDFButton({ atendimentos }) {
  return (
    <BlobProvider document={<RelatorioPDF atendimentos={atendimentos} />}>
      {({ url, loading, error }) => {
        if (loading) {
          // Usando o botão genérico com o estado de carregamento
          return (
            <Button
              type="default"
              label="Gerando PDF..."
              disabled={true}
              className="bg-gray-600 text-white p-3 rounded-md shadow-md"
            />
          );
        }

        if (error) {
          // Trate erros adequadamente, exibindo uma mensagem ou registrando o erro
          return <p>Erro ao gerar o PDF: {error.message}</p>;
        }

        return (
          <a href={url} download="relatorio_atendimentos.pdf">
            {/* Usando o botão genérico para o botão de download */}
            <Button
              type="salvar"
              label="Exportar para PDF"
              className="p-3 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            />
          </a>
        );
      }}
    </BlobProvider>
  );
}

// Adicionando propTypes para garantir que os atendimentos sejam fornecidos corretamente
DownloadPDFButton.propTypes = {
  atendimentos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      nomePaciente: PropTypes.string,
      clinica: PropTypes.string,
      dataAtendimento: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.object,
      ]),
      observacao: PropTypes.string,
    })
  ).isRequired,
};

export default DownloadPDFButton;
